class DTCCarousel extends HTMLElement {
    constructor() {
        super();
        this.slider = this.querySelector('.dtc-personalization-reviews__carousel');
        this.slides = Array.from(this.querySelectorAll('.dtc-personalization-reviews__item'));
        this.dotsContainer = this.querySelector('.dtc-personalization-reviews__carousel--dots');
        this.buttons = Array.from(this.querySelectorAll('.dtc-personalization-reviews__carousel--button'));
        this.currentIndex = 0;
        this.slideWidth = this.slides[0]?.offsetWidth;

        this.slider.addEventListener('scroll', () => {
            this.currentIndex = Math.round(this.slider.scrollLeft / this.slideWidth);
            this.update()
        });
    }

    connectedCallback() {
        this.createDots();
        this.attachListeners();
    }

    createDots() {
        this.slides.forEach((slide, index) => {
            const dot = document.createElement('div');
            dot.classList.add('dtc-personalization-reviews__dot');
            dot.setAttribute('data-index', index);
            index === 0 && dot.classList.add('active');
            this.dotsContainer.appendChild(dot);
        });

        this.dots = Array.from(this.querySelectorAll('.dtc-personalization-reviews__dot'));
    }

    attachListeners() {
        this.dots.forEach(dot => {
            dot.addEventListener('click', () => {
                this.currentIndex = parseInt(dot.getAttribute('data-index'));
                this.updateSlidePosition();
            });
        });

        this.buttons.forEach(button => {
            button.addEventListener('click', (evt) => {
                const eventTarget = evt.target.closest('.dtc-personalization-reviews__carousel--button');
                if (!!!eventTarget) return;

                if (eventTarget.dataset.direction == 'next') {
                    this.currentIndex = this.currentIndex === this.slides.length - 1 ? 0 : this.currentIndex + 1;
                    this.updateSlidePosition();
                    return
                }

                this.currentIndex = this.currentIndex === 0 ? this.slides.length - 1 : this.currentIndex - 1;
                this.updateSlidePosition();
            });
        })
    }

    update() {
        this.slides.forEach((slide, i) => {
            slide.classList.toggle('active', i === this.currentIndex);
        });

        this.dots.forEach((dot, i) => {
            dot.classList.toggle('active', i === this.currentIndex);
        });
    }

    updateSlidePosition() {
        this.slider.scrollTo({
            left: this.currentIndex * this.slideWidth,
            behavior: 'smooth'
        });
    }
}

customElements.define('dtc-carousel', DTCCarousel);